module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showModal) ? _c('banet-message', {
    on: {
      "close": function($event) {
        _vm.showModal = false
      }
    }
  }, [_c('h3', {
    slot: "header"
  }, [_vm._v(_vm._s(_vm.getTranslation('lbl_server_message')))]), _vm._v(" "), _c('h3', {
    slot: "body"
  }, [_vm._v(_vm._s(_vm.msgBody))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h2', [_c('router-link', {
    attrs: {
      "to": _vm.backLink
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })]), _vm._v("\n             " + _vm._s(_vm.getTranslation('lbl_user_edit_headline')) + "\n        ")], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [(_vm.refreshBlock) ? _c('div', {
    staticClass: "label-default"
  }, [_vm._v("\n                " + _vm._s(_vm.getTranslation('msg_user_updated')) + "\n                "), _c('button', {
    on: {
      "click": _vm.userRefresh
    }
  }, [_vm._v(_vm._s(_vm.getTranslation('lbl_refresh')))])]) : _vm._e(), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.save($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "firstName"
    }
  }, [_vm._v(_vm._s(_vm.getTranslation('lbl_user_first_name')) + " *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.firstName),
      expression: "user.firstName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "firstName",
      "formControlName": "firstName"
    },
    domProps: {
      "value": (_vm.user.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.firstName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "lastName"
    }
  }, [_vm._v(_vm._s(_vm.getTranslation('lbl_user_last_name')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.lastName),
      expression: "user.lastName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "lastName",
      "formControlName": "lastName"
    },
    domProps: {
      "value": (_vm.user.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.lastName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "username"
    }
  }, [_vm._v(_vm._s(_vm.getTranslation('lbl_username')) + " *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.username),
      expression: "user.username"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "username",
      "formControlName": "username"
    },
    domProps: {
      "value": (_vm.user.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v(_vm._s(_vm.getTranslation('lbl_user_mail')) + " *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "email",
      "formControlName": "email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "langSelector"
    }
  }, [_vm._v(_vm._s(_vm.getTranslation('lbl_language')))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.dropClose),
      expression: "dropClose"
    }],
    staticClass: "dropdown",
    class: {
      open: _vm.isOpened
    },
    attrs: {
      "id": "langSelector"
    }
  }, [_c('button', {
    staticClass: "dropdown-toggle form-control",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.dropToggle($event)
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.langString) + "\n                            "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    on: {
      "click": _vm.dropToggle
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setNewUserLanguage('de');
      }
    }
  }, [_vm._v(_vm._s(_vm.getTranslation('lbl_deutsch')))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setNewUserLanguage('en');
      }
    }
  }, [_vm._v(_vm._s(_vm.getTranslation('lbl_english')))])])])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.getTranslation('button_label_submit')))]), _vm._v(" "), _c('router-link', {
    staticClass: "btn",
    attrs: {
      "to": _vm.backLink,
      "tag": "button"
    }
  }, [_vm._v(_vm._s(_vm.getTranslation('app_lbl_action_cancel')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "well"
  }, [_c('h2', [_vm._v(_vm._s(_vm.getTranslation('headline_change_password')))]), _vm._v(" "), _c('form', {
    attrs: {
      "name": "chnPsw"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.changePsw($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "psw_set_1"
    }
  }, [_vm._v(_vm._s(_vm.getTranslation('frm_lbl_new_password_1')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.psw_set_1),
      expression: "psw_set_1"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "psw_set_1",
      "autocomplete": "new-password",
      "formControlName": "psw_set_1"
    },
    domProps: {
      "value": (_vm.psw_set_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.psw_set_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "psw_set_2"
    }
  }, [_vm._v(_vm._s(_vm.getTranslation('frm_lbl_new_password_2')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.psw_set_2),
      expression: "psw_set_2"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "psw_set_2",
      "formControlName": "psw_set_2"
    },
    domProps: {
      "value": (_vm.psw_set_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.psw_set_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changePsw($event)
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.getTranslation('btn_lbl_save_new_password')) + "\n                    ")])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1fabae39!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App/protected/components/user/UserEdit.vue
// module id = 669
// module chunks = 0